import { Product } from 'common/components/product-card/types';
import { Analytics } from '../products-carousel';

export const getAnalyticsData = (elementBlock: string, product: Product, analytics?: Analytics) => {
  switch (elementBlock) {
    case 'main_offer_2':
    case 'LMTYP':
      return {
        division: null,
        subdivision: null,
        productFamilyId: null,
      };
    case 'profile / purchases':
    case 'profile / shoppingList':
    case 'profile / purchase details':
    case 'profile / b2b / organization':
    case 'profile / b2b / purchases':
    case 'profile / b2b / purchase details':
    case 'recommendedProducts / basket': {
      return {
        brand: product.brand ?? null,
        category: product.compareCategory?.name ?? null,
        productFamilyId: product.compareCategory?.familyId ?? null,
        division: null,
        subdivision: null,
      };
    }
    case 'recommendedProducts':
    case 'substitutes':
    case 'complements':
    case 'productList / Catalog':
    case 'productList / SearchResults':
    case 'recommendedProducts / Catalog':
    case 'recommendedProducts / SearchResults':
    case 'brandShelf / Catalog':
    case 'brandShelf / SearchResults':
      return analytics || {};
    default:
      return {};
  }
};
